import { render, staticRenderFns } from "./office-rates-edit.vue?vue&type=template&id=54e2eb16&scoped=true&lang=pug"
import script from "./office-rates-edit.vue?vue&type=script&lang=ts"
export * from "./office-rates-edit.vue?vue&type=script&lang=ts"
import style0 from "./office-rates-edit.vue?vue&type=style&index=0&id=54e2eb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2eb16",
  null
  
)

export default component.exports